import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {AgencyAdAccountsAndStoresContent} from "./AgencyAdAccountsAndStoresContent";
import { withTranslation } from 'react-i18next';

class AgencyAdAccountsAndStores extends Component {
    constructor(props) {
        super(props);
        this.afterSuccessfulClientAdAccountSubmit = this.afterSuccessfulClientAdAccountSubmit.bind(this);
        this.afterSuccessfulClientAdAccountEdited = this.afterSuccessfulClientAdAccountEdited.bind(this);
        this.afterSuccessfulClientStoreSubmit = this.afterSuccessfulClientStoreSubmit.bind(this);
        this.afterSuccessfulClienttStoreEdited = this.afterSuccessfulClienttStoreEdited.bind(this);
        this.afterSuccessfulGiveAccessClientAdAccount = this.afterSuccessfulGiveAccessClientAdAccount.bind(this);
    }

    afterSuccessfulClientAdAccountSubmit(newClientAdAccountId) {
        const { t } = this.props;
        alert(t('agency_ad_accounts.account_linked_successfully'))
    }


    afterSuccessfulClientAdAccountEdited(newClientAdAccountId) {
        const { t } = this.props;
        alert(t('agency_ad_accounts.account_edited_successfully'))
    }

    afterSuccessfulClientStoreEdited(newClientAdAccountId) {
        const { t } = this.props;
        alert(t('agency_ad_accounts.store_edited_successfully'))
    }

    afterSuccessfulClientStoreSubmit(newClientAdAccountId) {
        const { t } = this.props;
        alert(t('agency_ad_accounts.store_linked_successfully'))
    }


    afterSuccessfulClienttStoreEdited(newClientAdAccountId) {
        const { t } = this.props;
        alert(t('agency_ad_accounts.store_edited_successfully'))
    }

    afterSuccessfulGiveAccessClientAdAccount(newClientAdAccountId) {
        const { t } = this.props;
        alert(t('agency_ad_accounts.invitation_sent_successfully'))
    }

    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <AgencyAdAccountsAndStoresContent afterSuccessfulClientAdAccountSubmit={this.afterSuccessfulClientAdAccountSubmit}
                                                  afterSuccessfulClientAdAccountEdited={this.afterSuccessfulClientAdAccountEdited}
                                                  afterSuccessfulClientStoreEdited={this.afterSuccessfulClientStoreEdited}
                                                  afterSuccessfulClienttStoreSubmit={this.afterSuccessfulClienttStoreSubmit}
                                                  afterSuccessfulClienttStoreEdited={this.afterSuccessfulClienttStoreEdited}
                                                  afterSuccessfulGiveAccessClientAdAccountSubmit={this.afterSuccessfulGiveAccessClientAdAccount}
                                                  location={this.props.location}
                />
            </div>
        )
    }
}

export default withTranslation()(AgencyAdAccountsAndStores);
